import axios from 'axios';

// The admin portal keeps its login token in the router's outlet context, not in sessionStorage;
// the page shell (SalesMachine.js) passes it here before any tab makes a call.
let token = '';
export const setToken = t => { token = t || ''; };
const url = path => `/api/admin/sales-machine${path}${path.includes('?') ? '&' : '?'}accesstoken=${token}`;

export const smGet = async path => (await axios.get(url(path))).data;
export const smPost = async (path, body = {}) => (await axios.post(url(path), body)).data;
export const smPut = async (path, body = {}) => (await axios.put(url(path), body)).data;
export const smDelete = async path => (await axios.delete(url(path))).data;

// The server's message for a failed call, in plain words.
export const errorText = e => e?.response?.data?.detail || e?.response?.data?.message || e?.message || 'Something went wrong.';

export const SIZE_RANGES = ['1,10', '11,50', '51,200', '201,500', '501,1000', '1001,2000', '2001,5000', '5001,10000', '10001,'];
export const sizeLabel = r => {
    const [a, b] = r.split(',');
    return b ? `${Number(a).toLocaleString('en')}–${Number(b).toLocaleString('en')}` : `${Number(a).toLocaleString('en')}+`;
};

export const personName = c => [c.firstName, c.lastName || c.lastNameMasked].filter(Boolean).join(' ');
